import { render, staticRenderFns } from "./ConfettiNotice.vue?vue&type=template&id=e7d3d488&scoped=true&"
import script from "./ConfettiNotice.vue?vue&type=script&lang=ts&"
export * from "./ConfettiNotice.vue?vue&type=script&lang=ts&"
import style0 from "./ConfettiNotice.vue?vue&type=style&index=0&id=e7d3d488&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d3d488",
  null
  
)

export default component.exports